<template>
  <bk-page 
		class="pointsRulesPage" 
		pageType="navPage" 
		:navBarInfo="navBarInfo"
		@close="close"
	>
		<bk-view class="view-box">
      <div v-html="showContent"></div>
    </bk-view>
  </bk-page>
</template>
  
<script>
	import { baseReq } from '@r';
	export default {
		name: 'pointsRules',
		props:{
			curRows:Object,
		},
		data () {
			return {
				showContent:'',
				navBarInfo:{
					langCode_title:'points_detail_rules',
					backFlag: true,
				}
			};
		},
		mounted (){
			this.requestGetPointRuleList();
		},
		methods: {
			close (){
				this.$emit('close');
			},
			async requestGetPointRuleList (){
				const { custId } = this.curRows;
				const resRule = await baseReq.requestGetPointRuleList(this, { custId, compCode:'001' });
				const { content	} = resRule['PR013'] || {};
				this.showContent = content; 
			},
		},
	};
</script>
  
<style lang='less'>
@import './pointsRules.less';
</style>
